import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FieldWrapper } from "@ngx-formly/core";
import { isObservable } from "rxjs";

@Component({
    standalone: false,
    templateUrl: "./horizontalInput.component.html",
})
export class FormlyHorizontalInput extends FieldWrapper {
    @ViewChild("fieldComponent", { read: ViewContainerRef })
    declare fieldComponent: ViewContainerRef;
    faInfoSign = faInfoCircle;

    // Dropdown/multiselect questions with no selectable options (e.g. a project has no active
    // lookup values configured for that type) should not be shown, unless the question is
    // required. Re-evaluated on every change detection so it stays correct if options are
    // populated asynchronously after this field first renders.
    isEmptyOptionalSelect(): boolean {
        if (this.field.type !== "hz-select" && this.field.type !== "multiSelect") return false;
        if (this.to?.required) return false;

        const options = (this.to as any)?.options;
        if (!options || isObservable(options)) return false;

        return options.length === 0;
    }
}
